export default "__VITE_ASSET__DC$4zJUr__"